import React from 'react'
import PropTypes from 'prop-types'
import Modal from '@codecraftkit/modal'
import { ProfileChangeImage } from '../ProfileChangeImage'

/** The dialog the picture is changed in. */
export const ProfileChangeImageModal = ({ onOpen, isOpen, onClose, modalTitle, size, boxSize, ...rest }) => (
  <Modal
    title={<span className='font-medium text-lg text-blue-600'>{modalTitle || 'Profile picture'}</span>}
    body={<ProfileChangeImage onCloseModal={onClose} {...rest} />}
    closeOnOverlayClick={false}
    onOpen={onOpen}
    isOpen={isOpen}
    onClose={onClose}
    size={boxSize ? undefined : (size || '800px')}
    boxSize={boxSize}
  />
)

ProfileChangeImageModal.propTypes = {
  onOpen: PropTypes.func,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  modalTitle: PropTypes.node,
  size: PropTypes.string,
  boxSize: PropTypes.string
}
